import { httpGet, httpPost } from "@eres/rest";
import { FinServResponse, RefundRequestModal, RePrintRequestModal } from "./entities";
import cfg from "@10x/tabu-mobile-api/dist/config";
import { validateFinDepApi } from "./services";

export function sendMailReceipt( request: RePrintRequestModal ): Promise<FinServResponse> {
	return httpPost( cfg.tabuAPI().endPoint() + `Tabu/RecieptArchive`, request ).then( validateFinDepApi );
}

export function getCertificateTypes() {
	return httpGet( cfg.tabuAPI().endPoint() + `Tabu/GetCertificateTypes` ).then( validateFinDepApi );
}

export function searchRequestByNumber( requestNumber: string ): Promise<FinServResponse> {
	return httpGet( cfg.tabuAPI().endPoint() + `Tabu/GetRefundRequest?requestNumber=${ requestNumber }` ).then( validateFinDepApi );
}

export function getDocumentLookup() {
	return httpGet( cfg.tabuAPI().endPoint() + `Lookup/GetLookup?name=feesrefund` );
}

export function sendOTPEmailMobile( email: string, mobile: string ) {
	return httpGet( cfg.tabuAPI().endPoint() + `Tabu/ValidateRequest?email=${ email }&mobile=${ mobile }` ).then( validateFinDepApi );
}

export function ValidateOTPEmailMobile( token: string, email: string, mobile: string ) {
	return httpGet( cfg.tabuAPI().endPoint() + `Users/GetVerifyRequestToken?token=${ token }&email=${ email }&mobile=${ mobile }` ).then( validateFinDepApi );
}

export function submitRefundRequest( request: RefundRequestModal ): Promise<FinServResponse> {
	return httpPost( cfg.tabuAPI().endPoint() + `Tabu/SaveRefundRequest`, request ).then( validateFinDepApi );
}
